import React from 'react';
import {Route} from 'react-router-dom';

export const displayRoutes = (routes) => {
  return routes.map((route, index) => {
    return (
      <Route exact key={index} path={route.path} element={route.component} />
    );
  });
};
